import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import FAQ from './FAQ';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

export default function FAQMain(){
  const { t, locale } = useLocale();
const[loader, SetLoader] = useState(false)
    useEffect(() =>
    setTimeout(() =>{
        SetLoader(true)
    },1500)[loader]  
    )
    if (!loader) {
        return <Loader/>;
    }
  return(
      <Fragment>
      <PageSEO title={t('meta.faqsTitle')} description={t('meta.faqsDescription')} path="/faqs" locale={locale} />
      <FAQ/>
      <Footer/>
      </Fragment>
  )
}
